import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonsService } from 'src/app/services/commons.service';

@Component({
  standalone: false,
  selector: 'app-signin2',
  templateUrl: './signin2.component.html',
  styleUrls: ['./signin2.component.scss'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(1300, style({ opacity: 1 }))
      ])
    ])
  ]
})
export class Signin2Component implements OnInit {
  constructor(private r: Router, private cs: CommonsService) { }

  ngOnInit() {
  }

  goToUrl = () => {
    this.r.navigateByUrl('home');
    this.cs.finishSession();
  }
}
